import React, {useState} from 'react';

import Input from '../../../CoreWrappers/Input';

const INPUT_NORMAL = 'inputNormal';
const INPUT_FILLED = 'inputFilled';
const INPUT_ERROR = 'inputError';
const INPUT_DISABLED = 'inputDisabled';

const InputDrydock = () => {
	const [values, setValues] = useState({
		[INPUT_NORMAL]: '',
		[INPUT_FILLED]:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus efficitur rhoncus massa sit amet aliquam. Etiam a justo massa. Duis at eros tellus. Nunc ut ultricies sapien. Nulla pretium metus interdum, sodales tellus sed, mollis lectus. Aliquam rhoncus metus lectus, at venenatis augue volutpat rhoncus. Sed et libero in ex auctor fringilla. Sed ultrices, tellus ac interdum dictum, elit est luctus neque, ac mattis turpis lectus sed urna. Morbi iaculis ac mi non placerat. Nullam volutpat dui ut.',
		[INPUT_ERROR]: ''
	});

	const handleChange = (id, newValue) => setValues({...values, [id]: newValue});

	const renderInputNormal = () => {
		const id = INPUT_NORMAL;
		const props = {
			id,
			value: values[id],
			onChange: (e) => handleChange(id, e.target.value),
			label: 'Input label'
		};

		return <Input {...props} />;
	};

	const renderInputFilled = () => {
		const id = INPUT_FILLED;
		const props = {
			id,
			value: values[id],
			onChange: (e) => handleChange(id, e.target.value),
			label: 'Input label'
		};

		return <Input {...props} />;
	};

	const renderInputError = () => {
		const id = INPUT_ERROR;
		const props = {
			id,
			value: values[id],
			onChange: (e) => handleChange(id, e.target.value),
			label: 'Input label',
			errorMessage: 'This is an error message'
		};

		return <Input {...props} />;
	};

	const renderInputDisabled = () => {
		const id = INPUT_DISABLED;
		const props = {
			id,
			value: values[id],
			onChange: (e) => handleChange(id, e.target.value),
			label: 'Input label',
			disabled: true
		};

		return <Input {...props} />;
	};

	return (
		<>
			{renderInputNormal()}
			{renderInputFilled()}
			{renderInputError()}
			{renderInputDisabled()}
		</>
	);
};

export default InputDrydock;
